import React from "react";
import Container from "./Container";
import { useTranslation } from "react-i18next";
import { Phone, Mail } from "lucide-react";

export default function Footer() {
  const { t } = useTranslation();

  // 🔧 여기만 바꾸면 전체 반영
  const PHONE = "010-5956-6965";
  const EMAIL = "probeit1@naver.com";

  // i18n 배열 없을 때 폴백
  const taglines = t("footer.taglines", { returnObjects: true }) || [
    "Strategic Global Recruiting & Staffing",
    "Professional F&B Operation Outsourcing Business",
    "K-FOOD Training & Business Development",
    "Expert Searching and Management Outsourcing",
  ];

  return (
    <footer className="border-t bg-white">
      <Container className="grid grid-cols-1 gap-8 py-10 md:grid-cols-3">
        {/* 회사/태그라인 */}
        <div>
          <div className="text-2xl md:text-3xl font-semibold tracking-tight">
            {t("brand")}
          </div>
          <ul className="mt-2 space-y-0.5 text-[11px] md:text-xs text-slate-600 tracking-tight">
            {taglines.map((line) => (
              <li key={line} className="flex items-start leading-tight">
                <span>{line}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* 연락처 */}
        <div className="text-sm text-slate-600">
          <div className="font-semibold text-slate-900">
            {t("footer.contact")}
          </div>
          <div className="mt-2 space-y-1.5">
            <a
              href={`tel:${PHONE.replace(/[^+\d]/g, "")}`}
              className="inline-flex items-center gap-2 text-slate-700 hover:text-blue-900"
              aria-label={t("contact.callUs")}
              title={t("contact.callUs")}
            >
              <Phone className="h-4 w-4" />
              <span className="tabular-nums">{PHONE}</span>
            </a>
            <a
              href={`mailto:${EMAIL}`}
              className="block text-slate-700 hover:text-blue-900"
              aria-label={t("contact.emailUs")}
              title={t("contact.emailUs")}
            >
              <span className="inline-flex items-center gap-2">
                <Mail className="h-4 w-4" />
                {EMAIL}
              </span>
            </a>
          </div>
        </div>

        {/* 링크 */}
        <div className="text-sm text-slate-600">
          <div className="font-semibold text-slate-900">
            {t("footer.links")}
          </div>
          <ul className="mt-1 space-y-1">
            <li>
              <a href="/about-us" className="hover:underline">
                {t("nav.about")}
              </a>
            </li>
            <li>
              <a href="/news" className="hover:underline">
                {t("nav.news")}
              </a>
            </li>
            <li>
              <a href="/faq" className="hover:underline">
                {t("nav.faq")}
              </a>
            </li>
            <li>
              <a href="/inquiry" className="hover:underline">
                {t("nav.inquiry")}
              </a>
            </li>
            <li>
              <a href="/contact-us" className="hover:underline">
                {t("nav.apply")}
              </a>
            </li>
          </ul>
        </div>
      </Container>

      <div className="border-t py-4 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} {t("brand")}. {t("footer.rights")}
      </div>
    </footer>
  );
}
